// @flow
import { downloadFile } from '../App/Utils/utils'

export const ADD_DOWNLOAD = 'DownloadManager/ADD_DOWNLOAD';
export const ADD_DOWNLOAD_PAUSED = 'DownloadManager/ADD_DOWNLOAD_PAUSED';
export const REQUEUE_DOWNLOAD = 'DownloadManager/REQUEUE_DOWNLOAD';
export const PAUSE_DOWNLOAD = 'DownloadManager/PAUSE_DOWNLOAD';
export const RESUME_DOWNLOAD = 'DownloadManager/RESUME_DOWNLOAD';
export const PAUSE_ITEM_DOWNLOAD = 'DownloadManager/PAUSE_ITEM_DOWNLOAD';
export const RESUME_ITEM_DOWNLOAD = 'DownloadManager/RESUME_ITEM_DOWNLOAD';
export const CANCEL_DOWNLOAD = 'DownloadManager/CANCEL_DOWNLOAD';
export const FINISH_DOWNLOAD = 'DownloadManager/FINISH_DOWNLOAD';

export const ADD_TO_DOWNLOAD_REQUEST = 'DownloadManager/ADD_TO_DOWNLOAD_REQUEST';
export const REMOVE_FROM_DOWNLOAD_REQUEST = 'DownloadManager/REMOVE_FROM_DOWNLOAD_REQUEST';
export const RESET_DOWNLOAD_REQUEST = 'DownloadManager/RESET_DOWNLOAD_REQUEST';

export const SAVE_DOCUMENT_START = 'DownloadManager/SAVE_DOCUMENT_START';
export const SAVE_DOCUMENT_SUCCESS = 'DownloadManager/SAVE_DOCUMENT_SUCCESS';
export const SAVE_DOCUMENT_FAILED = 'DownloadManager/SAVE_DOCUMENT_FAILED';

export const REFRESH_DOWNLOAD_PROGRESS = 'DownloadManager/REFRESH_DOWNLOAD_PROGRESS';
export const INDEX_CONTENT_START = 'DownloadManager/INDEX_CONTENT_START';
export const INDEX_CONTENT_SUCCESS = 'DownloadManager/INDEX_CONTENT_SUCCESS';
export const INDEX_CONTENT_FAILED = 'DownloadManager/INDEX_CONTENT_FAILED';

export const CLEAN_COMPLETED_DOWNLOADS = 'DownloadManager/CLEAN_COMPLETED_DOWNLOADS';

export const DOWNLOAD_FILE_START = 'DownloadManager/DOWNLOAD_FILE_START';
export const DOWNLOAD_FILE_FINISH = 'DownloadManager/DOWNLOAD_FILE_FINISH';

export const ADD_ITEM_TO_QUEUE = 'DownloadManager/ADD_ITEM_TO_QUEUE';
export const REMOVE_ITEM_FROM_QUEUE = 'DownloadManager/REMOVE_ITEM_FROM_QUEUE';

export const IMMEDIATELY_CLEAR_REMAINING_QUEUE = "DownloadManager/IMMEDIATELY_CLEAR_REMAINING_QUEUE";

export const ADD_PLAYLIST_TO_DOWNLOAD_QUEUE = 'DownloadManager/ADD_PLAYLIST_TO_DOWNLOAD_QUEUE';
export const REMOVE_PLAYLIST_FROM_DOWNLOAD_QUEUE = 'DownloadManager/REMOVE_PLAYLIST_FROM_DOWNLOAD_QUEUE';

export const MOVE_UP_DOWNLOAD = 'DownloadManager/MOVE_UP_DOWNLOAD';
export const MOVE_DOWN_DOWNLOAD = 'DownloadManager/MOVE_DOWN_DOWNLOAD';

export function addToDownloadRequest( resID ) {
    return {
        request: resID,
        type: ADD_TO_DOWNLOAD_REQUEST
    };
}

export function removeFromDownloadRequest( resID ) {
    return {
        request: resID,
        type: REMOVE_FROM_DOWNLOAD_REQUEST
    };
}

export function resetDownloadRequest() {
    return {
        type: RESET_DOWNLOAD_REQUEST
    };
}

export function addDownload(doc) {
    return {
        document: { metadata: doc, isDownloading: false },
        type: ADD_DOWNLOAD
    };
}

export function addDownloadPaused(doc) {
    return {
        document: { metadata: doc, isDownloading: false },
        type: ADD_DOWNLOAD_PAUSED
    };
}

export function requeueDownload( doc ) {
    // console.info( "requeueDownload action", doc );
    doc.wentTrhoughRequeueDownloadAction = true;
    return {
        document: { metadata: doc, isDownloading: false },
        type: REQUEUE_DOWNLOAD
    };
}

export function saveDocument() {
    return {
        types: [ SAVE_DOCUMENT_START, SAVE_DOCUMENT_SUCCESS, SAVE_DOCUMENT_FAILED ],
    };
}

export function indexContent() {
    // console.info( "indexContent dispatched, promises indexAllDocumentsFromDB" )
    return {
        types: [ INDEX_CONTENT_START, INDEX_CONTENT_SUCCESS, INDEX_CONTENT_FAILED ],
    };

}

export function cleanCompletedDownloads() {
    // console.info( "'cleanCompletedDownloads' action triggered" )
    return {
        type: CLEAN_COMPLETED_DOWNLOADS
    }
}

export function downloadFileStart( file ) {
    // console.info( "'downloadFileStart' action invoked" );
    // console.info( "'downloadFileStart' received 'file': ", file );
    downloadFile( file );
    return {
        type: DOWNLOAD_FILE_START,
        file_id: file.file_id
    }
}

export function downloadFileFinish() {
    return {
        type: DOWNLOAD_FILE_FINISH,
    }
}

export function refreshDownloadProgress( data ) {

    return {
        type: REFRESH_DOWNLOAD_PROGRESS,
        progress: Math.floor( data.percentage * 100 ),
        size: data.size,
        downloaded: data.downloaded,
        speed: data.speed,
        time: data.time
    }
}

export function pauseDownload( index ) {
    return {
        type: PAUSE_DOWNLOAD,
        index
    }
}

export function resumeDownload( index ) {
    return {
        type: RESUME_DOWNLOAD,
        index
    }
}

export function pauseItemDownload( itemID ) {
    return {
        type: PAUSE_ITEM_DOWNLOAD,
        itemID
    }
}

export function resumeItemDownload( itemID ) {
    return {
        type: RESUME_ITEM_DOWNLOAD,
        itemID
    }
}

export function cancelDownload( index ) {
    return {
        type: CANCEL_DOWNLOAD,
        index
    }
}

export function addItemToQueue( item ) {
    return {
        type: ADD_ITEM_TO_QUEUE,
        item
    }
}

export function removeItemFromQueue( itemID ) {
    return {
        type: REMOVE_ITEM_FROM_QUEUE,
        itemID: itemID
    }
}

export function immediatelyClearRemainingQueue() {
    return {
        type: IMMEDIATELY_CLEAR_REMAINING_QUEUE,
    }
}

export function addPlaylistToDownloadQueue( playlistID ) {
    return {
        type: ADD_PLAYLIST_TO_DOWNLOAD_QUEUE,
        playlistID
    }
}

export function removePlaylistFromDownloadQueue( playlistID ) {
    return {
        type: REMOVE_PLAYLIST_FROM_DOWNLOAD_QUEUE,
        playlistID: playlistID
    }
}

export function moveUpDownload(index) {
    return {
        type: MOVE_UP_DOWNLOAD,
        index
    }
}

export function moveDownDownload(index) {
    return {
        type: MOVE_DOWN_DOWNLOAD,
        index
    }
}
